/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AptosCodeBlockInfo = {
    type?: AptosCodeBlockInfo.type;
    data?: string;
};

export namespace AptosCodeBlockInfo {

    export enum type {
        JSON = 'JSON',
    }


}

